module.exports = __webpack_public_path__ + "media/demoVidep.bfc6174f.mp4";